import React, { useState, useEffect } from 'react';
import { Chart } from 'react-google-charts';
import { Doughnut } from 'react-chartjs-2';

const SummaryPieChart = ({
	channels,
	metricData,
	metricField,
	metricInitialVal,
}) => {
	const [currentData, setCurrentData] = useState([]);
	const [data, setData] = useState(null);
	const [metricFilter, setMetricFilter] = useState(metricInitialVal);
	// console.log('metricData', metricData);
	useEffect(() => {
		if (metricData && metricData.pieData) {
			const filterMetric = metricField[0].value;
			const filterChannel = channels[0] && channels[0].value;
			let data = [];
			if (filterMetric) {
				setMetricFilter(filterMetric);
				const field =
					Object.keys(metricData.pieData).length &&
					metricData.pieData[filterMetric];
				data = field;
			} else {
				setMetricFilter(metricInitialVal);
				const field =
					Object.keys(metricData.pieData).length &&
					metricData.pieData[metricInitialVal];
				data = Object.values(field);
			}

			// console.log('data', data);
			if (filterChannel) {
				data = data.filter((e) => e[0] !== filterChannel);
			}

			const newD = [['Promoter', 'Promoters'], ...data];
			if (newD) {
				setData(newD);
				setCurrentData(newD);
			}
		}
	}, [metricData, metricField, channels]);

	// console.log('currentData', currentData);

	return (
		<div>
			<Chart
				height={'330px'}
				chartType='PieChart'
				loader={<div>Loading Chart</div>}
				data={currentData}
				options={{
					width: '100%',
					title: metricFilter,
					pieHole: 0.4,
					legend: {
						position: 'right',
						alignment: 'center',
						// orientation: 'vertical',
					},
					// backgroundColor: '#263143',
					titleTextStyle: {
						fontSize: 21,
						color: '#666',
						alignment: 'center',
					},
				}}
				rootProps={{ 'data-testid': '1' }}
			/>
		</div>
	);
};

export default SummaryPieChart;
